import { useState } from 'react';
import CountFlow from './CountFlow';
import ServiceOrderFlow from './ServiceOrderFlow';
import ServiceOrderList from './ServiceOrderList';

/** O comportamento que tem tela própria (M9 — §6.9). */
const COUNT_BEHAVIOR_KEY = 'COUNT';

/**
 * O trabalho por ORDEM DE SERVIÇO no coletor (M5): a fila e a execução.
 *
 * São duas telas e um estado só — qual OS está na mão. Ficam juntas aqui, e não
 * na página, porque a página é o CHASSI do coletor (identificação, equipamento
 * da sessão, os modos do M4) e não deve aprender o vocabulário das OSs para
 * lembrar em qual delas o operador estava.
 *
 * A `key` do fluxo é o id da OS de propósito: trocar de OS não é atualizar uma
 * tela, é começar outro trabalho — remontar joga fora passo, LPN na mão e
 * torre carregada, que é exatamente o que se quer.
 */
const ServiceOrderCollector = ({ label, operator, onExit }) => {
    const [order, setOrder] = useState(null);

    if (!order) {
        return <ServiceOrderList label={label} operator={operator} onOpen={setOrder} onExit={onExit} />;
    }

    // M9 — a CONTAGEM tem tela própria porque não é um movimento: ela bipa
    // posição → LPN(s) → quantidade, e nada sai do lugar. O `behavior_key` vem
    // do DTO da OS (o aceite já devolve a ficha), então a escolha da tela é
    // feita aqui, no mesmo lugar onde a lista vira execução — e não dentro do
    // fluxo de movimento, que teria de aprender a não mover.
    if (order.behavior_key === COUNT_BEHAVIOR_KEY) {
        return (
            <CountFlow key={order.id} label={label} operator={operator} order={order} onExit={() => setOrder(null)} />
        );
    }

    return (
        <ServiceOrderFlow
            key={order.id}
            label={label}
            operator={operator}
            order={order}
            onExit={() => setOrder(null)}
        />
    );
};

export default ServiceOrderCollector;
